
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.7358 16.4964L19.3927 14.1533C19.1433 13.8988 18.8457 13.6966 18.5173 13.5586C18.1888 13.4206 17.8362 13.3495 17.4799 13.3495C17.1236 13.3495 16.771 13.4206 16.4425 13.5586C16.1141 13.6966 15.8165 13.8988 15.5671 14.1533L15.0985 14.6219C12.7383 12.6523 10.5587 10.4758 8.58556 8.1185L9.06375 7.64031C9.57068 7.13282 9.85542 6.44485 9.85542 5.72755C9.85542 5.01025 9.57068 4.32228 9.06375 3.81479L6.74931 1.50035C6.23701 1.00258 5.55085 0.724121 4.83655 0.724121C4.12225 0.724121 3.43609 1.00258 2.92379 1.50035L1.64224 2.7819C1.02802 3.40428 0.645551 4.2183 0.558542 5.08839C0.471533 5.95848 0.685231 6.83212 1.16405 7.5638C4.98596 13.3176 9.91853 18.2502 15.6723 22.0721C16.404 22.5509 17.2777 22.7646 18.1478 22.6776C19.0178 22.5906 19.8319 22.2081 20.4543 21.5939L21.7358 20.3219C21.9903 20.0726 22.1924 19.775 22.3304 19.4465C22.4685 19.1181 22.5396 18.7654 22.5396 18.4092C22.5396 18.0529 22.4685 17.7002 22.3304 17.3718C22.1924 17.0433 21.9903 16.7457 21.7358 16.4964Z","fill":"currentColor"}})])
          )
        }
      }
    